import { render } from "./notification-item.vue?vue&type=template&id=5e79641c"
import script from "./notification-item.vue?vue&type=script&lang=js"
export * from "./notification-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__